import { render, staticRenderFns } from "./DocumentsBatchRetrieve.vue?vue&type=template&id=4f5ebf6c"
import script from "./DocumentsBatchRetrieve.vue?vue&type=script&lang=js"
export * from "./DocumentsBatchRetrieve.vue?vue&type=script&lang=js"
import style0 from "./DocumentsBatchRetrieve.vue?vue&type=style&index=0&id=4f5ebf6c&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f5ebf6c')) {
      api.createRecord('4f5ebf6c', component.options)
    } else {
      api.reload('4f5ebf6c', component.options)
    }
    module.hot.accept("./DocumentsBatchRetrieve.vue?vue&type=template&id=4f5ebf6c", function () {
      api.rerender('4f5ebf6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/documents/batch/views/DocumentsBatchRetrieve.vue"
export default component.exports